import { CameraIcon, SmileIcon, VideoIcon } from 'lucide-preact';
import { useDispatch } from 'react-redux';

import { useHabitatLiveStreamPlayerContext } from '@/components/HabitatLiveStreamPlayer/contexts';
import ZoomBar from '@/components/LiveStream/StreamInteractiveArea/StreamControls/ZoomBar';
import { useLiveStreamPlayerStateContext } from '@/components/LiveStreamPlayer/contexts';
import useOpenSpeedyFlow from '@/components/SpeedyFlow/hooks/useOpenSpeedyFlow';
import { useSelector, useStore } from '@/redux/helper';

import { MOBILE_CONTROLS_HEIGHT } from '../../../habitat/constants';

const HomeLiveStreamPlayerFakeMobileControls = () => {
  const dispatch = useDispatch();
  const openSpeedyFlow = useOpenSpeedyFlow();
  const store = useStore();
  const { habitat } = useHabitatLiveStreamPlayerContext();
  const logged = useSelector((state) => state.user.logged);
  const { isPlaying } = useLiveStreamPlayerStateContext();
  if (!isPlaying) {
    return null;
  }
  const onClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (logged) {
      openSpeedyFlow({ kind: 'habitat-access', habitatId: habitat._id, entryPoint: 'home-player-fake-controls' });
    } else {
      openSpeedyFlow({ kind: 'account', entryPoint: 'home-player-fake-controls' });
    }
  };
  return (
    <div className="flex items-center gap-[10px] bg-primary-green" style={{ height: `${MOBILE_CONTROLS_HEIGHT}px` }}>
      <div className="flex items-center justify-center">
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <VideoIcon className="size-[1.33em]" />
        </button>
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <CameraIcon className="size-[1.33em]" />
        </button>
        <button type="button" onClick={onClick} className="preflight preflight-button size-10 text-white">
          <SmileIcon className="size-[1.33em]" />
        </button>
      </div>
      <button type="button" className="preflight preflight-button mr-[10px] grow" onClick={onClick}>
        <ZoomBar horizontal height="38px" className="!pointer-events-none" />
      </button>
    </div>
  );
};

export default HomeLiveStreamPlayerFakeMobileControls;
